import { render, staticRenderFns } from "./ProjectPriceDialog.vue?vue&type=template&id=92a9516e&"
import script from "./ProjectPriceDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectPriceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports